<template>
  <div v-if="getExperiencesBrij.length > 0">
    <Navigation
      :headerExpArry="getExperiencesBrij"
      @changeHeaderExp="getExperience($event)"
    />
    <div class="container cinema-exp">
      <div class="content-box pt-4">
        <div class="main-heading">
          <div>
            <hr class="primary-line" />
          </div>
          <div v-if="experience" class="title">
            {{ allLanguageData.WhatIs }}
            {{
              experience.translation_data && experience.translation_data.length
                ? experience.translation_data.filter(
                    (x) => x.langaugeId == getCurrentLang().brij_lang_id
                  )[0].movie_experience_name || experience.name
                : experience.name
            }}
          </div>
        </div>
        <div class="content mb-4">
          <!--          <div class="content-title my-3">-->
          <!--            {{ experience.movie_experience }}-->
          <!--          </div>-->
          <div class="content-desc" v-html="experienceDesc"></div>
        </div>
        <div class="row content video-box mx-0 pt-1 justify-content-center">
          <div class="col-md-8 px-0 order-2 order-md-1 emp-bgblack">
            <iframe
              :src="'https://www.youtube.com/embed/' + videoID + '?controls=0'"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              frameborder="0"
              height="315"
              title="YouTube video player"
              width="100%"
            ></iframe>
          </div>
          <div class="col-md-4 px-0 video-content py-4 px-3 order-1 order-md-2">
            <div class="px-lg-5">
              <div class="mb-lg-4 quote-start">
                <img
                  src="@/assets/img/new-img/svg-img/quote.svg"
                  width="50px"
                />
              </div>
              <div class="mb-0 text">{{ allLanguageData.ExpCinemaSpace }}</div>
              <div class="mt-lg-4 quote-end">
                <img
                  src="@/assets/img/new-img/svg-img/quote.svg"
                  width="50px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-box pt-4">
        <div class="content mb-4">
          <div
            class="content-desc mt-2 pt-1"
            v-if="
              selectedCinemaValues.filter((c) => c.cinema_id !== '').length >=
                0 ||
              selectedExpValues.length >= 0 ||
              selectedLang.length >= 0 ||
              (getMovies && getMovies.length >= 0)
            "
          >
            <!-- <div class="mt-3">
                <ul class="px-3">
                  <li>
                    when an unknown printer took a galley of type and scrambled it
                    to make a type specimen book.
                  </li>
                  <li>
                    when an unknown printer took a galley of type and scrambled it
                    to make a type specimen book.
                  </li>
                  <li>
                    when an unknown printer took a galley of type and scrambled it
                    to make a type specimen book.
                  </li>
                  <li>
                    when an unknown printer took a galley of type and scrambled it
                    to make a type specimen book.
                  </li>
                </ul>
              </div> -->
            <div class="mt-3">
              <div class="content-title">
                {{ allLanguageData.Filters[0].title }}
              </div>
              <div class="filter-dropdown row mx-0 my-3">
                <div class="col-md-3 col-lg-3 px-0 pr-md-2 mb-3">
                  <multiselect
                    v-model="selectedCinemaValues"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :custom-label="getCinemaTranslatedName"
                    :deselect-label="''"
                    :multiple="true"
                    :options="getBrijCinemas"
                    :preserve-search="true"
                    :select-label="''"
                    :selectedLabel="''"
                    class="custom-multiselect scroll-dropdown screen-multiselect"
                    :placeholder="allLanguageData.QuickBook.selectCinema"
                    track-by="cinema_id"
                    :class="{ 'multiselect-arabic': langName === 'ar' }"
                    :style="{ textAlign: langName === 'ar' ? 'right' : 'left' }"
                  >
                    <template
                      slot="selection"
                      slot-scope="{ values, search, isOpen }"
                    >
                      <span
                        v-if="values.length>1 && values.length &amp;&amp; !isOpen"
                        class="multiselect__single"
                        >{{ values.length }}
                        {{
                          langName === "ar" ? "دور السينما" : "Cinemas"
                        }}</span
                      >
                      <span
                        v-else-if=" values.length &amp;&amp; !isOpen"
                        class="multiselect__single"
                        >{{
                          getCinemaTranslatedName(values[0]) ||
                          values[0].CinemaName
                        }}</span
                      ></template
                    >
                  </multiselect>
                  <!-- <b-dropdown
                      variant="default"
                      class="quickbook-dropdown"
                      text="Select Location"
                    >
                      <b-dropdown-item v-for="(data, Index) in 10" :key="Index"
                        >Cinema One</b-dropdown-item
                      >
                    </b-dropdown> -->
                </div>
                <!-- <div class="col-md-3 col-lg-3 px-0 pr-md-2 mb-3">
                    <multiselect
                      v-model="selectedExpValues"
                      :clear-on-select="false"
                      :close-on-select="true"
                      :deselect-label="''"
                      :multiple="true"
                      :options="getNowShowingGenre"
                      :preserve-search="true"
                      :select-label="''"
                      :selectedLabel="''"
                      class="custom-multiselect scroll-dropdown screen-multiselect"
                      label="GenreName"
                      :placeholder="allLanguageData.QuickBook.selectgenre"
                      track-by="GenreID"
                    >
                      <template
                        slot="selection"
                        slot-scope="{ values, search, isOpen }"
                        ><span
                          v-if="values.length &amp;&amp; !isOpen"
                          class="multiselect__single"
                          >{{ values.length }} Genre</span
                        ></template
                      >
                    </multiselect> -->
                <!-- <b-dropdown
                      variant="default"
                      class="quickbook-dropdown"
                      text="Genre"
                    >
                      <b-dropdown-item v-for="(data, Index) in 10" :key="Index"
                        >Cinema One</b-dropdown-item
                      >
                    </b-dropdown> -->
                <!-- </div> -->
                <div class="col-md-3 col-lg-3 px-0 pr-md-2">
                  <multiselect
                    v-model="selectedDates"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :deselect-label="''"
                    :multiple="true"
                    :options="getAvailableDates"
                    :preserve-search="true"
                    :select-label="''"
                    :selectedLabel="''"
                    class="custom-multiselect scroll-dropdown screen-multiselect"
                    :placeholder="allLanguageData.QuickBook.selectDate"
                    track-by="date"
                    :class="{ 'multiselect-arabic': langName === 'ar' }"
                    :style="{ textAlign: langName === 'ar' ? 'right' : 'left' }"
                  >
                    <template slot="singleLabel" slot-scope="{ option }">
                      {{ formatDate(option) }}
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      {{ formatDate(option) }}
                    </template>
                    <template
                      slot="selection"
                      slot-scope="{ values, search, isOpen }"
                    >
                      <span
                        v-if="values.length &amp;&amp; !isOpen"
                        class="multiselect__single"
                      >
                        {{ values.length }}
                        {{ langName === "ar" ? "التاريخ" : "Dates" }}
                      </span>
                    </template>
                    <template slot="noOptions">
                      <span>
                        {{
                          langName === "ar" ? "القائمة فارغة" : "LIST IS EMPTY"
                        }}
                      </span>
                    </template>
                  </multiselect>
                </div>
                <div class="col-md-3 col-lg-3 px-0 pr-md-2">
                  <multiselect
                    v-model="selectedLang"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :deselect-label="''"
                    :multiple="true"
                    :options="getNowShowingLanguages"
                    :preserve-search="true"
                    :select-label="''"
                    :selectedLabel="''"
                    class="custom-multiselect scroll-dropdown screen-multiselect"
                    label="LanguageName"
                    :placeholder="allLanguageData.QuickBook.selectlanguage"
                    track-by="LanguageID"
                    :class="{ 'multiselect-arabic': langName === 'ar' }"
                    :style="{ textAlign: langName === 'ar' ? 'right' : 'left' }"
                  >
                    <template
                      slot="selection"
                      slot-scope="{ values, search, isOpen }"
                      ><span
                        v-if="values.length &amp;&amp; !isOpen"
                        class="multiselect__single"
                        >{{ values.length }}
                        {{ langName === "ar" ? "لغة" : "Language" }}</span
                      ></template
                    >
                    <template slot="noOptions">
                      <span>
                        {{
                          langName === "ar" ? "القائمة فارغة" : "LIST IS EMPTY"
                        }}
                      </span>
                    </template>
                  </multiselect>
                  <!-- <b-dropdown
                      variant="default"
                      class="quickbook-dropdown"
                      text="Language"
                    >
                      <b-dropdown-item v-for="(data, Index) in 10" :key="Index"
                        >Cinema One</b-dropdown-item
                      >
                    </b-dropdown> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <MovieSlider
          v-if="
            selectedCinemaValues.filter((c) => c.cinema_id !== '').length > 0 ||
            selectedExpValues.length > 0 ||
            selectedLang.length > 0 ||
            (getMovies && getMovies.length > 0)
          "
          :key="componentKeySlider"
          :moviesArray="getMovies"
          bgcolor="emp-bgprimary"
          booknow="true"
          class="my-4"
          movieIndex="showmovies"
          oppbgcolor="emp-bgsecondary"
        />
      </div>
    </div>
  </div>
</template>
<script>
import MovieSlider from "@/components/partials/movieSlider.vue";
import Navigation from "@/components/pages/experience/expnavigation.vue";
import { makeRequest, makeRequestBrij } from "@/helper/internet.js";
import { LanguageService } from "@/services/storage.service";

export default {
  components: {
    MovieSlider,
    Navigation,
  },
  mounted() {
    let language = LanguageService.getLanguage();
    if (!language) {
      this.LanguageID = 2;
    } else {
      this.LanguageID = language.lang_id;
    }
    // this.handleResize();
    let lang = LanguageService.getLanguage();
    if (lang == null) {
      this.langName = "eng";
    } else {
      this.langName = lang["lang"];
    }
  },
  beforeMount() {
    this.headerExpId = this.$route.params.expID;
    this.headerExpName = this.$route.params.expName;
    this.getExperience(this.headerExpId);

    // this.getExperienceList()
    // this.fetchCinemaList()
  },
  data() {
    return {
      experience: null,
      experienceDesc: "",
      videoID: "",
      showExpBanners: [],
      filteredExpArray: [],
      selectedExpValues: [],
      selectedLang: [],
      filteredTimesArray: [],
      All_languagesArray: [],
      AllGenresArray: [],
      filteredCinamaArray: [],
      selectedCinemaValues: [],
      cinemaList: [],
      experienceListData: [],
      experienceMovieListData: [],
      headerExpId: "",
      headerExpName: "",
      headerHeadingName: "",
      headerDescName: "",
      headerTrailName: "",
      componentKeySlider: 0,
      hideCinemaFilter: false,
      selectedDates: [],
    };
  },
  computed: {
    // getAvailableDates() {
    //   let allDates = this.getMovies
    //     .map((movie) => movie.show_actual_time)
    //     .flat();
    //   let avail = [...new Set(allDates)];
    //   console.log("avail:", avail);

    //   // return [...new Set(allDates)];
    //   return avail;
    // },
    getAvailableDates() {
      let nowShowing = this.$store.getters.getNowShowing.data || [];
      let allDates = [
        ...nowShowing
          .map((n) => ({
            date: n.show_actual_time,
          }))
          .sort((a, b) => new Date(a.date) - new Date(b.date)),
      ];

      let availableDates = [
        ...new Set(allDates.map((n) => JSON.stringify(n))),
      ].map((s) => JSON.parse(s));

      return availableDates;
    },
    getNowShowingLanguages() {
      let nowShowing = this.$store.getters.getNowShowing.data || [];
      // let upcoming = this.$store.getters.getUpcoming.data || []
      let langs = [
        ...nowShowing.map((n) => ({
          // LanguageName: n.lang_name,
          LanguageName:
            this.langName === "ar" ? this.toArabic(n.lang_name) : n.lang_name,
          LanguageID: n.lang_id,
        })),
        // ...upcoming.map(n => ({ LanguageName: n.lang_name, LanguageID: n.lang_id }))
      ];

      return [...new Set(langs.map((n) => JSON.stringify(n)))].map((s) =>
        JSON.parse(s)
      );
    },
    getNowShowingGenre() {
      let nowShowing = this.$store.getters.getNowShowing.data || [];
      // let upcoming = this.$store.getters.getUpcoming.data || []

      let genres = [
        ...nowShowing.flatMap((n) => n.genres_with_translations),
        // ...upcoming.map(n => ({ LanguageName: n.lang_name, LanguageID: n.lang_id }))
      ];

      genres.forEach((g) => {
        g.GenreID = g.genre_id;
        g.GenreName = g.key;
      });

      // return genres.map(n => ({ Genre: n, GenreID: n }))
      // return [
      //   ...new Map(
      //     genres.map((item) => [item["GenreID"], item])
      //   ).values(),
      // ]
      return [...new Set(genres.map((n) => JSON.stringify(n)))].map((s) =>
        JSON.parse(s)
      );
    },
    getBrijCinemas() {
      return [
        {
          cinema_id: "",
          // cinema_name: "All",
          cinema_name: this.langName === "ar" ? "الكل" : "All",
          cinema_code: "All",
          // CinemaName: "ALL CINEMAS",
          CinemaName: this.langName === "ar" ? "كل السينما" : "ALL CINEMAS",
          CinemaID: "ALL",
        },
        ...(this.$store.getters.getBrijCinemas
          ? this.$store.getters.getBrijCinemas
          : []),
      ].filter((e) => {
        if (Object.keys(this.experience).length === 0) return true;

        if (!this.experience.hasOwnProperty("cinema_ids")) return true;

        if (this.experience.cinema_ids == "") return true;

        return this.getSafe(
          () => this.experience.cinema_ids.split(""),
          []
        ).includes(`${e.cinema_id}`);
      });
    },
    getNowShowing() {
      return this.$store.getters.getNowShowing;
    },
    getUpcoming() {
      return this.$store.getters.getUpcoming;
    },
    // getExperiencesBrij() {
    //   return this.$store.getters.getExperiences;
    // }
    getExperiencesBrij() {
      // Filter experiences to include only premiere experiences
      return this.$store.getters.getExperiences.filter(
        (experience) => experience.movie_experience === "PREMIERE"
      );
    },

    headerCinemaId() {
      return this.$store.state.headerCinemaStore.headerCinemaId;
    },

    getMovies() {
      let filtered = JSON.parse(JSON.stringify(this.getNowShowing.data));

      let isAllCinemaSelected = this.selectedCinemaValues.some(
        (c) => c.cinema_id === ""
      );
      if (isAllCinemaSelected) this.selectedCinemaValues = [];

      let cinema_ids = this.selectedCinemaValues
        .map((c) => c.cinema_id)
        .filter((x) => !!x);
      let genre_ids = this.selectedExpValues
        .map((c) => c.GenreID)
        .filter((x) => !!x);
      let lang_ids = this.selectedLang
        .map((c) => c.LanguageID)
        .filter((x) => !!x);
      let date_ids = this.selectedDates
        ? this.selectedDates.map((c) => c.date).filter((x) => !!x)
        : [];

      filtered = filtered
        .filter((x) => {
          let f = x.format_name_array
            .map((x) => String(x).toLowerCase())
            .map((x) => {
              if (x.includes("atmos") || x.includes("dolby")) return "atmos";
              if (x.includes("sphera")) return "sphera";
              if (x.includes("flexound")) return "flexound";
              if (x.includes("premiere")) return "premiere";

              if (x == "screen x") return "screenx";
              if (x == "4 dx" || x == "4d x") return "4dx";

              return x;
            });

          let s =
            String(this.$route.params.expName).includes("atmos") ||
            String(this.$route.params.expName).includes("dolby")
              ? "atmos"
              : String(this.$route.params.expName).includes("sphera")
              ? "sphera"
              : String(this.$route.params.expName).includes("flexound")
              ? "flexound"
              : String(this.$route.params.expName).includes("premiere")
              ? "premiere"
              : String(this.$route.params.expName);

          // console.log({
          //   movie_title: x.movie_title,
          //   f: f.join(','),
          //   s,
          //   res: f.includes(s)
          // })

          return f.includes(s);
        })
        .filter((x) => {
          if (isAllCinemaSelected || cinema_ids.length === 0) return true;

          let cine_ids = x.cine_ids
            .split(",")
            .filter((x) => !!x)
            .map((x) => parseInt(x, 10));

          return cinema_ids.some((x) => cine_ids.includes(x));
        })
        .filter((x) => {
          if (genre_ids.length === 0) return true;

          return genre_ids.includes(x.genre_id);
        })
        .filter((x) => {
          if (lang_ids.length === 0) return true;

          return lang_ids.includes(x.lang_id);
        });

      let fil = filtered.filter((x) => {
        return date_ids.length === 0 || date_ids.includes(x.show_actual_time);
      });

      this.componentKeySlider += 1;
      return fil;
    },
  },
  watch: {
    "$route.params": {
      handler: function (newVal, oldVal) {
        console.log("$router.params", { newVal, oldVal });
        this.headerExpName = newVal.expName || this.headerExpName;
      },
      deep: true,
    },
  },
  methods: {
    toArabic(name) {
      const arabicTranslations = {
        Tagalog: "التاغالوغية",
        Hindi: "الهندية",
        Malayalam: "المالايالامية",
        English: "إنجليزي",
        Arabic: "العربية",
        Tamil: "التاميل",
      };
      return arabicTranslations[name] || name;
    },
    formatDate(dateString) {
      let d = typeof dateString === "string" ? dateString : dateString.date;
      const date = new Date(d);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const langIsArabic = this.langName === "ar";
      // const ampm = hours >= 12 ? "PM" : "AM";
      // const formattedHours = hours % 12 || 12;
      const ampm = langIsArabic
        ? hours >= 12
          ? "م"
          : "ص"
        : hours >= 12
        ? "PM"
        : "AM";
      const formattedHours = langIsArabic
        ? ((hours + 11) % 12) + 1
        : hours % 12 || 12;

      const formattedDate = `${day}-${month}-${year}`;
      const formattedTime = `${formattedHours}:${minutes} ${ampm}`;
      return `${formattedDate} ${formattedTime}`;
    },
    getCinemaTranslatedName(cinema) {
      if (!cinema) return "";

      let name =
        this.getLangSpecificAttribute(
          cinema.translation_data || [],
          this.getCurrentLang().brij_lang_id,
          "cinema_name",
          "langaugeId"
        ) || cinema.cinema_name;
      return name;
    },
    fetchCinemaList: function () {
      makeRequest("/GetCinemas", "POST", null, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (res.data) {
            this.cinemaList = res.data.Categories;

            let objcinemaAll = {
              CinemaName: "ALL CINEMAS",
              CinemaID: "ALL",
            };

            this.cinemaList.unshift(objcinemaAll);

            let obj = this.cinemaList.filter((y) => {
              return y.CinemaID == this.headerCinemaId;
            });
            if (obj.length > 0) {
              this.selectedCinemaValues.push(...obj);
              this.hideCinemaFilter = true;
            }
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    getMoviesByFormat() {
      this.hideLoading();
      this.showLoading();
      this.componentKeySlider += 1;
      this.experienceMovieListData = [];
      let payload = {
        Experience: this.headerExpName,
        ExperienceID: this.headerExpId,
        CinemaID: this.filteredCinamaArray,
        GenreID: this.filteredExpArray,
        MovieLanguageID: this.filteredTimesArray,
      };

      makeRequest("/GetMoviesByExperience/", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          this.hideLoading();
          if (res.data.hasOwnProperty("Shows") && res.data.Shows.length > 0) {
            this.experienceMovieListData = res.data.Shows[0].show;
          }

          if (
            res.data.hasOwnProperty("AllGenres") &&
            res.data.AllGenres.length > 0
          ) {
            this.AllGenresArray = res.data.AllGenres;
          }

          if (
            res.data.hasOwnProperty("All_languages") &&
            res.data.All_languages.length > 0
          ) {
            this.All_languagesArray = res.data.All_languages;
          }

          this.hideLoading();
        })

        .catch((error) => {
          this.hideLoading();
          console.log("Error", error);
        });
    },

    ChangeExp(headerExpId) {
      console.log("ChangeExp", { headerExpId });
      this.headerExpId = headerExpId;
      let experienceDetailsAr = this.experienceListData.filter((x) => {
        return x.ID == headerExpId;
      });

      if (experienceDetailsAr.length > 0) {
        this.headerExpName = experienceDetailsAr[0].name;
        this.headerHeadingName = experienceDetailsAr[0].heading;
        this.headerDescName = experienceDetailsAr[0].description;
        this.headerTrailName = experienceDetailsAr[0].trailer;
        window.localStorage.setItem("EXPE", this.headerExpName);
        this.getMoviesByFormat();
      }
    },
    getExperienceList() {
      this.showLoading();
      this.experienceListData = [];
      makeRequest("/GetExperience/", "POST", null, null)
        .then((response) => {
          const { error, res } = response;
          if (
            res.data.hasOwnProperty("Categories") &&
            res.data.Categories.length > 0
          ) {
            this.experienceListData = res.data.Categories;
          }
          this.getMoviesByFormat();
          this.hideLoading();
        })

        .catch((error) => {
          this.hideLoading();
          console.log("Error", error);
        });
    },

    async getExperience(headerExpId = null) {
      this.hideLoading();
      this.showLoading();
      this.ChangeExp(headerExpId);
      if (headerExpId) {
        this.headerExpId = headerExpId;
      }

      this.selectedCinemaValues = [];
      this.selectedExpValues = [];
      this.selectedLang = [];

      try {
        let response = await makeRequestBrij(
          `/api/admin/experience-format/${this.headerExpId}`,
          "GET",
          null,
          null
        );
        const { error, res } = response;

        if (res.data.status) {
          let { data } = res;
          data.Records = data.Records.filter(
            (record) => record.movie_experience === "PREMIERE"
          );

          data.Records.forEach((e) => {
            e.ID = e.movie_experience_id;
            e.name = e.movie_experience;

            try {
              e.translation_data = JSON.parse(e.translation_data);
            } catch (e) {
              console.log("translation_data parse error", e);
              e.translation_data = [];
            }
          });

          this.experience = data.Records[0] ? data.Records[0] : null;

          if (data.Records[0]) {
            this.videoID =
              this.getLangSpecificAttribute(
                this.experience.translation_data,
                this.getCurrentLang().brij_lang_id,
                "movie_experience_link",
                "langaugeId"
              ) || "";

            console.log(`${this.videoID}`);
            if (this.videoID && this.videoID.includes("http")) {
              this.videoID = this.videoID
                .slice(this.videoID.lastIndexOf("v="))
                .split("v=")[1];
            }
            console.log(`${this.videoID}`);

            let experienceDesc =
              this.getLangSpecificAttribute(
                this.experience.translation_data,
                this.getCurrentLang().brij_lang_id,
                "movie_experience_description",
                "langaugeId"
              ) || "";

            this.experienceDesc = experienceDesc.split("&lt;").join("<");
          }
          this.$forceUpdate();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.hideLoading();
      }
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/experience/premiere.vue